const translations = {
  'My Team': {
    en: 'My Team',
    es: 'Mi Equipo',
    pt: 'Meu time',
  },
  'My teams': {
    en: 'My teams',
    es: 'Mis equipos',
    pt: 'Meu times',
  },
  'Add teams': {
    en: 'Add teams',
    es: 'Agregar equipos',
    pt: 'Adicionar times',
  },
  'Favorite team': {
    en: 'Favorite team',
    es: 'Equipo favorito',
    pt: 'Time favorito',
  },
  'Add a favorite team to customize your experience': {
    en: 'Add a favorite team to customize your experience',
    es: 'Agrega un equipo favorito para personalizar tu experiencia',
    pt: 'Adicione um time favorito para personalizar sua experiência',
  },
  'Unfollow team': {
    en: 'Unfollow team',
    es: 'Dejar de seguir',
    pt: 'Deixar de seguir',
  },
  'Follow your teams': {
    en: 'Follow your teams',
    es: 'Sigue a tus equipos',
    pt: 'Siga suas times',
  },
  'Select your teams to continue': {
    en: 'Select your teams to continue',
    es: 'Selecciona los equipos que deseas seguir para continuar',
    pt: 'Selecione suas times para continuar',
  },
  'Filter by Tournament': {
    en: 'Filter by Tournament',
    es: 'Filtrar por torneo',
    pt: 'Filtrar por torneio',
  },
  'Follow selected teams': {
    en: 'Follow selected teams',
    es: 'Seguir equipos',
    pt: 'Siga as times',
  },
  'teams selected': {
    en: 'teams selected',
    es: 'equipos seleccionados',
    pt: 'times selecionadas',
  },
  'Do you want to unfollow': {
    en: 'Do you want to unfollow',
    es: '¿Quieres dejar de seguir a',
    pt: 'Deseja deixar de seguir a',
  },
  'Follow your teams and stay up to date with the latest events': {
    en: 'Follow your teams and stay up to date with the latest events',
    es: 'Sigue a tus equipos y mantente al día de los últimos acontecimientos',
    pt: 'Acompanhe suas equipes e fique por dentro dos últimos eventos'
  },
  'Pick your favorite team': {
    en: 'Pick your favorite team',
    es: 'Elige tu equipo favorito',
    pt: 'Escolha seu time favorito'
  },
  'You selected': {
    en: 'You selected',
    es: 'Has seleccionado',
    pt: 'Você selecionou'
  },
  'as your favorite team': {
    en: 'as your favorite team',
    es: 'como tu equipo favorito',
    pt: 'como seu time favorito'
  },
  'You have chosen': {
    en: 'You have chosen',
    es: '¡Has elegido',
    pt: 'Você escolheu'
  },
  'as your favorite team!': {
    en: 'as your favorite team!',
    es: 'como tu equipo favorito!',
    pt: 'como seu time favorito!'
  },
  'Skip for now': {
    en: 'Skip for now',
    es: 'Omitir por ahora',
    pt: 'Pular por enquanto'
  },
  'Confirm selection': {
    en: 'Confirm selection',
    es: 'Confirmar selección',
    pt: 'Confirmar seleção'
  },
  'We could not save your favorite team. Please try again.': {
    en: 'We could not save your favorite team. Please try again.',
    es: 'No pudimos guardar tu equipo favorito. Vuelve a intentarlo.',
    pt: 'Não foi possível salvar seu time favorito. Tente novamente.'
  },
  'Follow team': {
    en: 'Follow team',
    es: 'Seguir equipo',
    pt: 'Seguir time'
  },
  'Change team': {
    en: 'Change team',
    es: 'Cambiar equipo',
    pt: 'Trocar time'
  },
  'Change': {
    en: 'Change',
    es: 'Cambiar',
    pt: 'Trocar'
  },
  'NEXT MATCH': {
    en: 'NEXT MATCH',
    es: 'PRÓXIMO PARTIDO',
    pt: 'PRÓXIMA PARTIDA'
  },
  'View event details': {
    en: 'View event details',
    es: 'Ver detalles del evento',
    pt: 'Ver detalhes do evento'
  },
  'Expand standings': {
    en: 'Expand standings',
    es: 'Expandir posiciones',
    pt: 'Expandir classificação'
  },
  'Past Matches': {
    en: '{team}, Past Matches',
    es: '{team}, Partidos Pasados',
    pt: '{team}, Partidas Passadas'
  },
  // Standings column headers. Snake_case and scoped, not the usual natural-phrase
  // key: the value IS the abbreviation, so there is no English sentence to key on,
  // and the letters collide across languages — `P` is Played in English and
  // Perdidos in Spanish — which an abbreviation-as-key would merge into one entry.
  // Spanish values are the ones that shipped hardcoded; en/pt follow the
  // conventional league-table sets and are the ones worth confirming with design.
  'standings_played': {
    en: 'P',
    es: 'J',
    pt: 'J'
  },
  'standings_won': {
    en: 'W',
    es: 'G',
    pt: 'V'
  },
  'standings_drawn': {
    en: 'D',
    es: 'E',
    pt: 'E'
  },
  'standings_lost': {
    en: 'L',
    es: 'P',
    pt: 'D'
  },
  'standings_goals_for': {
    en: 'GF',
    es: 'GF',
    pt: 'GP'
  },
  'standings_goals_against': {
    en: 'GA',
    es: 'GC',
    pt: 'GC'
  },
  'standings_goal_difference': {
    en: 'GD',
    es: 'DIF',
    pt: 'SG'
  },
  'standings_points': {
    en: 'PTS',
    es: 'PTS',
    pt: 'PTS'
  },

  // Tournament detail (PRO-402). UI chrome only — tab, stage and season labels
  // always come from the standings response, never from here.
  // The value is the API's season name — '2026' for a calendar-year league,
  // '2026-2027' for a split one. Only the word around it is ours.
  'Season {season}': {
    en: 'Season {season}',
    es: 'Temporada {season}',
    pt: 'Temporada {season}',
  },
  'Standings': {
    en: 'Standings',
    es: 'Posiciones',
    pt: 'Classificação',
  },
  'Top scorers': {
    en: 'Top scorers',
    es: 'Goleadores',
    pt: 'Artilheiros',
  },
  'Top assists': {
    en: 'Top assists',
    es: 'Asistencias',
    pt: 'Assistências',
  },
  'Collapse': {
    en: 'Collapse',
    es: 'Contraer',
    pt: 'Recolher',
  },
  'Expand': {
    en: 'Expand',
    es: 'Expandir',
    pt: 'Expandir',
  },
  'Standings {context}': {
    en: 'Standings {context}',
    es: 'Posición {context}',
    pt: 'Classificação {context}'
  },
  'This tournament link is not valid.': {
    en: 'This tournament link is not valid.',
    es: 'Este enlace de torneo no es válido.',
    pt: 'Este link de torneio não é válido.'
  },
  'We could not load the standings right now.': {
    en: 'We could not load the standings right now.',
    es: 'No pudimos cargar las posiciones en este momento.',
    pt: 'Não foi possível carregar a classificação agora.'
  },
  'Go to my team': {
    en: 'Go to my team',
    es: 'Ir a mi equipo',
    pt: 'Ir para meu time'
  },
  'No standings available': {
    en: 'No standings available',
    es: 'Posiciones no disponibles',
    pt: 'Classificação indisponível'
  },
  'There are no standings for this stage yet.': {
    en: 'There are no standings for this stage yet.',
    es: 'Aún no hay posiciones para esta fase.',
    pt: 'Ainda não há classificação para esta fase.'
  },
  'This view is not available yet': {
    en: 'This view is not available yet',
    es: 'Esta vista aún no está disponible',
    pt: 'Esta visualização ainda não está disponível'
  },
  'We are still working on this section. Check back soon.': {
    en: 'We are still working on this section. Check back soon.',
    es: 'Seguimos trabajando en esta sección. Vuelve pronto.',
    pt: 'Ainda estamos trabalhando nesta seção. Volte em breve.'
  },
  'Watch replay': {
    en: 'Watch replay',
    es: 'Ver repetición',
    pt: 'Ver replay'
  },
  'LIVE MATCH': {
    en: 'LIVE MATCH',
    es: 'PARTIDO EN VIVO',
    pt: 'PARTIDA AO VIVO'
  },
  'Watch live now': {
    en: 'Watch live now',
    es: 'Ver en vivo ahora',
    pt: 'Assistir ao vivo agora'
  },
  'Team roster {team}': {
    en: 'Roster {team}',
    es: 'Plantel {team}',
    pt: 'Elenco {team}'
  },
  'We could not load your team information right now. Please try again later.': {
    en: 'We could not load your team information right now. Please try again later.',
    es: 'No pudimos cargar la información de tu equipo en este momento. Inténtalo de nuevo más tarde.',
    pt: 'Não foi possível carregar as informações do seu time agora. Tente novamente mais tarde.'
  },
}

export default translations